import React, { useMemo, useState } from 'react'
import useCashierProducts from '../../hooks/useCashierProducts'

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const { products, loading, error } = useCashierProducts()

  const filteredProducts = useMemo(() => {
    if (!searchTerm) return products

    const term = searchTerm.toLowerCase()
    return products.filter((item) => {
      const valuesToCheck = [
        item.product_name,
        item.product_sku,
        item.supplier_name,
      ]

      return valuesToCheck.some((value) =>
        value?.toLowerCase().includes(term)
      )
    })
  }, [products, searchTerm])

  const totalUnits = useMemo(() => {
    return filteredProducts.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity)
      return Number.isNaN(quantity) ? sum : sum + quantity
    }, 0)
  }, [filteredProducts])

  return (
    <>
      <div className="pagetitle">
        <h1>Products</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            <li className="breadcrumb-item active">Products</li>
          </ol>
        </nav>
      </div>
      {/* End Page Title */}
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                  <div>
                    <h5 className="card-title mb-1">Cashier Product List</h5>
                    <p className="text-muted mb-0">
                      Showing {filteredProducts.length} items • Total units{' '}
                      {totalUnits.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                    </p>
                  </div>
                  <div className="w-100 w-md-50">
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by name, SKU, branch or supplier"
                      value={searchTerm}
                      onChange={(event) => setSearchTerm(event.target.value)}
                    />
                  </div>
                </div>

                {loading && (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}

                {!loading && error && (
                  <div className="alert alert-danger my-3 mb-0" role="alert">
                    {error}
                  </div>
                )}

                {!loading && !error && filteredProducts.length === 0 && (
                  <div className="alert alert-info my-3 mb-0" role="alert">
                    No products match your search right now.
                  </div>
                )}

                {!loading && !error && filteredProducts.length > 0 && (
                  <div className="table-responsive mt-3">
                    <table className="table table-striped table-hover align-middle">
                      <thead>
                        <tr className="table-light">
                          <th className="text-uppercase small text-muted">
                            Batch #
                          </th>
                          <th className="text-uppercase small text-muted">
                            Product
                          </th>
                          <th className="text-uppercase small text-muted">
                            SKU
                          </th>
                          <th className="text-end text-uppercase small text-muted">
                            Qty
                          </th>
                          <th className="text-end text-uppercase small text-muted">
                            Price
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredProducts.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <span className="badge bg-light text-dark border">
                                {item.batch_number || 'N/A'}
                              </span>
                            </td>
                            <td>
                              <div className="fw-semibold text-capitalize mb-1">
                                {item.product_name || 'N/A'}
                              </div>
                              <small className="text-muted">
                                Supplier: {item.supplier_name || '—'}
                              </small>
                            </td>
                            <td>{item.product_sku || 'N/A'}</td>
                            <td className="text-end">
                              {Number(item.quantity).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="text-end">
                              {Number(item.selling_price).toLocaleString(
                                undefined,
                                {
                                  style: 'currency',
                                  currency: 'USD',
                                }
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Products

